// import React, { useState, useEffect } from 'react';
// import { 
//   AppBar, 
//   Toolbar, 
//   Typography, 
//   Button, 
//   IconButton, 
//   Drawer, 
//   List, 
//   ListItem, 
//   ListItemText, 
//   Box, 
//   Container,
//   Divider,
//   Fade
// } from '@mui/material';
// import MenuIcon from '@mui/icons-material/Menu';
// import CloseIcon from '@mui/icons-material/Close';

// // तुमचा लोगो पाथ
// import LogoImg from '../images/logo1.jpg'; 

// const Navbar = () => {
//   const [mobileOpen, setMobileOpen] = useState(false);
//   const [scrolled, setScrolled] = useState(false);

//   // कलर्स
//   const deepGolden = "#B8860B"; 
//   const saffronGradient = "linear-gradient(90deg, #FF8C00 0%, #F39C12 50%, #B8860B 100%)";

//   // स्मूथ स्क्रोलिंग फंक्शन
//   const scrollToSection = (id) => {
//     const element = document.getElementById(id);
//     if (element) {
//       const offset = 70; // नॅव्हबारची उंची वजा केली जेणेकरून हेडिंग झाकले जाणार नाही
//       const bodyRect = document.body.getBoundingClientRect().top;
//       const elementRect = element.getBoundingClientRect().top;
//       const elementPosition = elementRect - bodyRect;
//       const offsetPosition = elementPosition - offset;

//       window.scrollTo({
//         top: offsetPosition,
//         behavior: 'smooth'
//       });
//     }
//     setMobileOpen(false); // क्लिक केल्यावर मोबाईल मेनू बंद होईल
//   };

//   useEffect(() => {
//     const handleScroll = () => {
//       setScrolled(window.scrollY > 10);
//     };
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const navItems = [
//     { label: "मुख्य", to: "home" },
//     { label: "आमच्या विषयी", to: "about" },
//     { label: "सेवा", to: "services" },
//     { label: "संगीत संग्रह", to: "music" },
//     { label: "उत्पादने", to: "products" },
//     { label: "संपर्क", to: "contact" },
//   ];

//   const handleDrawerToggle = () => {
//     setMobileOpen(!mobileOpen);
//   };

//   return (
//     <>
//       <AppBar 
//         position="sticky" 
//         sx={{ 
//           background: saffronGradient,
//           boxShadow: scrolled ? '0px 4px 20px rgba(0,0,0,0.2)' : 'none',
//           transition: 'all 0.4s ease',
//           py: { xs: 0.5, md: 1 },
//           top: 0,
//           zIndex: 1100
//         }}
//       >
//         <Container maxWidth="xl">
//           <Toolbar disableGutters sx={{ display: 'flex', justifyContent: 'space-between' }}>
            
//             {/* --- LOGO SECTION --- */}
//             <Box 
//               onClick={() => scrollToSection('home')} 
//               sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
//             >
//               <Box 
//                 sx={{ 
//                   position: 'relative',
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   mr: 2,
//                   '&::after': {
//                     content: '""',
//                     position: 'absolute',
//                     width: { xs: 52, md: 62 },
//                     height: { xs: 52, md: 62 },
//                     border: '2px solid #fff',
//                     borderRadius: '50%',
//                     boxShadow: `0 0 10px ${deepGolden}`
//                   }
//                 }}
//               >
//                 <Box 
//                   component="img"
//                   src={LogoImg}
//                   alt="Logo"
//                   sx={{ 
//                     height: { xs: 45, md: 55 }, 
//                     width: { xs: 45, md: 55 }, 
//                     borderRadius: '50%',
//                     zIndex: 2,
//                     objectFit: 'cover'
//                   }}
//                 />
//               </Box>
//               <Box>
//                 <Typography 
//                   variant="h5" 
//                   sx={{ 
//                     fontWeight: 900, 
//                     color: '#fff', 
//                     fontFamily: "'serif'",
//                     textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
//                     lineHeight: 1
//                   }}
//                 >
//                   जिनभक्ती
//                 </Typography>
//                 <Typography 
//                   variant="caption" 
//                   sx={{ color: '#fff', fontSize: '0.7rem', fontWeight: 600, opacity: 0.9 }}
//                 >
//                   जिनभक्ती स्वर संगीत ग्रुप
//                 </Typography>
//               </Box>
//             </Box>

//             {/* --- DESKTOP MENU --- */}
//             <Box sx={{ display: { xs: 'none', md: 'block' } }}>
//               {navItems.map((item) => (
//                 <Button 
//                   key={item.label} 
//                   onClick={() => scrollToSection(item.to)} // इथे बदल केला आहे
//                   sx={{ 
//                     color: '#fff', 
//                     mx: 1, 
//                     fontWeight: 700,
//                     fontSize: '1rem',
//                     textTransform: 'none',
//                     '&:hover': { color: '#FFE4B5', transform: 'translateY(-2px)' },
//                     transition: '0.3s'
//                   }}
//                 >
//                   {item.label}
//                 </Button>
//               ))}
//             </Box>

//             {/* --- MOBILE ICON --- */}
//             <IconButton
//               onClick={handleDrawerToggle}
//               sx={{ display: { md: 'none' }, color: '#fff', bgcolor: 'rgba(255,255,255,0.2)' }}
//             >
//               <MenuIcon fontSize="large" />
//             </IconButton>

//           </Toolbar>
//         </Container>
//       </AppBar>

//       {/* --- MOBILE DRAWER --- */}
//       <Drawer
//         anchor="right"
//         open={mobileOpen}
//         onClose={handleDrawerToggle}
//         PaperProps={{ 
//           sx: { 
//             width: 280, 
//             background: saffronGradient,
//             color: '#fff' 
//           } 
//         }}
//       >
//         <Box sx={{ p: 2, display: 'flex', justifyContent: 'flex-end' }}>
//           <IconButton onClick={handleDrawerToggle} sx={{ color: '#fff' }}>
//             <CloseIcon fontSize="large" />
//           </IconButton>
//         </Box>

//         <Box sx={{ textAlign: 'center', mb: 3 }}>
//            <Typography variant="h5" sx={{ fontWeight: 'bold', letterSpacing: 1 }}>मेनू</Typography>
//            <Divider sx={{ bgcolor: 'rgba(255,255,255,0.3)', mt: 1 }} />
//         </Box>

//         <List sx={{ px: 2 }}>
//           {navItems.map((item, index) => (
//             <Fade in={mobileOpen} timeout={(index + 1) * 200} key={item.label}>
//               <ListItem 
//                 button 
//                 onClick={() => scrollToSection(item.to)} // मोबाईलमध्ये पण स्क्रोल चालेल
//                 sx={{ 
//                   mb: 1.5, 
//                   borderRadius: '12px', 
//                   bgcolor: 'rgba(255,255,255,0.1)',
//                   '&:hover': { bgcolor: 'rgba(255,255,255,0.2)' }
//                 }}
//               >
//                 <ListItemText 
//                   primary={item.label} 
//                   primaryTypographyProps={{ fontSize: '1.1rem', fontWeight: 700, textAlign: 'center' }} 
//                 />
//               </ListItem>
//             </Fade>
//           ))}
//         </List>
//       </Drawer>
//     </>
//   );
// };

// export default Navbar;   

import React, { useState, useEffect } from 'react';
import { 
  AppBar, 
  Toolbar, 
  Typography, 
  Button, 
  IconButton, 
  Drawer, 
  List, 
  ListItem, 
  Box, 
  Container,
  Divider,
  Fade,
  Tooltip
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import AppIcon from '@mui/icons-material/ShopTwo'; 

// तुमचा लोगो पाथ
import LogoImg from '../images/logo1.jpg'; 

const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  // कलर्स
  const deepGolden = "#B8860B"; 
  const saffronGradient = "linear-gradient(90deg, #FF8C00 0%, #F39C12 50%, #B8860B 100%)";
  const apkDownloadPath = "/apk/JinbhaktiApp(09-06-2026).apk";

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 70; 
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
    setMobileOpen(false); 
  };

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { label: "मुख्य", to: "home" },
    { label: "आमच्या विषयी", to: "about" },
    { label: "सेवा", to: "services" },
    { label: "संगीत संग्रह", to: "music" },
    { label: "उत्पादने", to: "products" },
    { label: "संपर्क", to: "contact" },
  ];

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <>
      <AppBar 
        position="sticky" 
        sx={{ 
          background: saffronGradient,
          boxShadow: scrolled ? '0px 4px 20px rgba(0,0,0,0.2)' : 'none',
          transition: 'all 0.4s ease',
          py: { xs: 0.5, md: 1 },
          top: 0,
          zIndex: 1100
        }}
      >
        <Container maxWidth="xl">
          <Toolbar disableGutters sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            
            {/* --- LOGO SECTION --- */}
            <Box 
              onClick={() => scrollToSection('home')} 
              sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
            >
              <Box 
                sx={{ 
                  position: 'relative',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mr: 2,
                  '&::after': {
                    content: '""',
                    position: 'absolute',
                    width: { xs: 52, md: 62 },
                    height: { xs: 52, md: 62 },
                    border: '2px solid #fff',
                    borderRadius: '50%',
                    boxShadow: `0 0 10px ${deepGolden}`
                  }
                }}
              >
                <Box 
                  component="img"
                  src={LogoImg}
                  alt="Logo"
                  sx={{ 
                    height: { xs: 45, md: 55 }, 
                    width: { xs: 45, md: 55 }, 
                    borderRadius: '50%',
                    zIndex: 2,
                    objectFit: 'cover'
                  }}
                />
              </Box>
              <Box>
                <Typography 
                  variant="h5" 
                  sx={{ 
                    fontWeight: 900, 
                    color: '#fff', 
                    fontFamily: "'serif'",
                    textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
                    lineHeight: 1
                  }}
                >
                  जिनभक्ती
                </Typography>
                <Typography 
                  variant="caption" 
                  sx={{ color: '#fff', fontSize: '0.7rem', fontWeight: 600, opacity: 0.9 }}
                >
                  जिनभक्ती स्वर संगीत ग्रुप
                </Typography>
              </Box>
            </Box>

            {/* --- DESKTOP VIEW --- */}
            <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center' }}>
              {navItems.map((item) => (
                <Button 
                  key={item.label} 
                  onClick={() => scrollToSection(item.to)} 
                  sx={{ 
                    color: '#fff', 
                    mx: 1, 
                    fontWeight: 700,
                    fontSize: '1rem',
                    textTransform: 'none',
                    '&:hover': { color: '#FFE4B5', transform: 'translateY(-2px)' },
                    transition: '0.3s'
                  }}
                >
                  {item.label}
                </Button>
              ))}

              {/* --- "Download App" बटण (होव्हरवर पांढराच रंग राहील) --- */}
              <Tooltip title="Download APK" arrow placement="bottom">
                <Button
                  component="a"
                  href={apkDownloadPath}
                  download="JinbhaktiApp.apk"
                  variant="contained"
                  startIcon={<AppIcon />}
                  sx={{
                    ml: 2,
                    bgcolor: '#fff',
                    color: '#FF8C00',
                    fontWeight: 'bold',
                    borderRadius: '30px', 
                    px: 3,
                    py: 0.8,
                    textTransform: 'none',
                    boxShadow: '0px 4px 10px rgba(0,0,0,0.15)',
                    '&:hover': {
                      bgcolor: '#fff', // होव्हर केल्यावर रंग पांढराच राहील
                      boxShadow: '0px 6px 15px rgba(0,0,0,0.25)', // फक्त शॅडो वाढेल
                      transform: 'scale(1.03)', // हलकेसे झूम होईल
                    },
                    transition: 'all 0.3s ease'
                  }}
                >
                  Download App
                </Button>
              </Tooltip>
            </Box>

            {/* --- MOBILE VIEW HEADER --- */}
            <Box sx={{ display: { xs: 'flex', md: 'none' }, alignItems: 'center' }}>
              <IconButton
                onClick={handleDrawerToggle}
                sx={{ color: '#fff', bgcolor: 'rgba(255,255,255,0.2)' }}
              >
                <MenuIcon fontSize="large" />
              </IconButton>
            </Box>

          </Toolbar>
        </Container>
      </AppBar>

      {/* --- MOBILE DRAWER --- */}
      <Drawer
        anchor="right"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        PaperProps={{ 
          sx: { 
            width: 280, 
            background: saffronGradient,
            color: '#fff' 
          } 
        }}
      >
        <Box sx={{ p: 2, display: 'flex', justifyContent: 'flex-end' }}>
          <IconButton onClick={handleDrawerToggle} sx={{ color: '#fff' }}>
            <CloseIcon fontSize="large" />
          </IconButton>
        </Box>

        <Box sx={{ textAlign: 'center', mb: 3 }}>
           <Typography variant="h5" sx={{ fontWeight: 'bold', letterSpacing: 1 }}>मेनू</Typography>
           <Divider sx={{ bgcolor: 'rgba(255,255,255,0.3)', mt: 1 }} />
        </Box>

        <List sx={{ px: 2 }}>
          {navItems.map((item, index) => (
            <Fade in={mobileOpen} timeout={(index + 1) * 200} key={item.label}>
              <ListItem 
                button 
                onClick={() => scrollToSection(item.to)} 
                sx={{ 
                  mb: 1.5, 
                  borderRadius: '12px', 
                  bgcolor: 'rgba(255,255,255,0.1)',
                  '&:hover': { bgcolor: 'rgba(255,255,255,0.2)' },
                  justifyContent: 'center'
                }}
              >
                <Typography sx={{ fontSize: '1.1rem', fontWeight: 700, width: '100%', textAlign: 'center' }}>
                  {item.label}
                </Typography>
              </ListItem>
            </Fade>
          ))}

          {/* मोबाईल मेनूमधील बटण (होव्हरवर पांढरेच राहील) */}
          <Fade in={mobileOpen} timeout={(navItems.length + 1) * 200}>
            <ListItem sx={{ justifyContent: 'center', mt: 3, px: 1 }}>
              <Button
                component="a"
                href={apkDownloadPath}
                download="JinbhaktiApp.apk"
                variant="contained"
                startIcon={<AppIcon />}
                onClick={() => setMobileOpen(false)}
                sx={{
                  bgcolor: '#fff',
                  color: '#FF8C00',
                  fontWeight: 'bold',
                  borderRadius: '30px', 
                  fontSize: '1rem',
                  py: 1,
                  width: '100%', 
                  textTransform: 'none',
                  boxShadow: '0px 4px 12px rgba(0,0,0,0.2)',
                  '&:hover': { 
                    bgcolor: '#fff', // मोबाईलवर पण होव्हरवर पांढराच रंग राहील
                  },
                  transition: 'all 0.3s ease'
                }}
              >
                Download App
              </Button>
            </ListItem>
          </Fade>
        </List>
      </Drawer>
    </>
  );
};

export default Navbar;